import { render, staticRenderFns } from "./ManterFaqsView.vue?vue&type=template&id=5705c45a"
import script from "./ManterFaqsView.vue?vue&type=script&lang=js"
export * from "./ManterFaqsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports